import { APIResponse } from '..';
import { postMethod } from '../helpers';
import { hesselApiTypes } from '../models/hessel-api';

export const submitHireLeadCheckout = async (data: hesselApiTypes.HireLeadCheckoutSubmit): APIResponse<hesselApiTypes.HireLeadCheckoutResponse> => {
    return postMethod<hesselApiTypes.HireLeadCheckoutResponse>(`api/v3/lead/hire`, data);
};

export const submitSelectedLeasingLeadCheckout = async (
    data: hesselApiTypes.SelectedLeasingCheckoutSubmit
): APIResponse<hesselApiTypes.HireLeadCheckoutResponse> => {
    return postMethod<hesselApiTypes.HireLeadCheckoutResponse>(`api/v3/lead/selected-leasing`, data);
};
